module.exports = __webpack_public_path__ + "static/img/COC2023-1.9dd6101.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-1.png
// module id = opEA
// module chunks = 0